module.exports = {
  PANEL_HEADER_CENTERED_TEXT: 'PanelHeaderCenteredText',
  PANEL_HEADER_ILLUSTRATION: 'PanelHeaderIllustration'
};